
<template>
    <div class="com-item"  :key="index">
        <div class="component person-nav">
            <div class="van-sticky" v-if="modata.WContent.nav && modata.WContent.nav.length>0">
                <div class="pic2-content"  :style="{padding:'0 '+(modata.WContent.moduleSpac||0)*proportion+'px',}">
                    <div class='imgNav-4' v-if="modata.WContent.moduleStyle==5" :style="{gap:(modata.WContent.imgSpac*proportion)+'px'}">
                        <div v-for="(item,index) in modata.WContent.nav" :key="index" :class="{'col-span-2':index==1}">
                            <div class="imgNav-item_box">
                              <el-image :src="item.imgUrl" class='imgNav-item_img' v-if="item.imgUrl"></el-image>
                              <btnModule :content-obj="modata.WContent.btnData1" :nav="item" type="preview" :key="index" v-if="index==0" :proportion="proportion"></btnModule>
                              <btnModule :content-obj="modata.WContent.btnData2" :nav="item" type="preview" :key="index" v-else-if="index==1" :proportion="proportion"></btnModule>
                              <btnModule :content-obj="modata.WContent" :nav="item" type="preview" :key="index" :proportion="proportion" v-else></btnModule>
                            </div>
                        </div>
                        
                    </div>

                    <div class='imgNav-1' v-else>
                        <template v-for="(item,index) in modata.WContent.nav">
                            <div :style="{width:(modata.WContent.imgSpac*proportion)+'px',height:(modata.WContent.imgSpac*proportion)+'px'}" v-if="index>0" :key="'_'+index"></div>
                            <div class="imgNav-item"  @click="bindPage(item)" :key="index">
                                <div class="imgNav-item_box" :class="['imgNav-item_box'+index]">
                                    <el-image :src="item.imgUrl" class='imgNav-item_img' v-if="item.imgUrl"></el-image>
                                    <btnModule :content-obj="modata.WContent" :nav="item" :animate-show="animateShow"  :proportion="proportion"></btnModule>
                                </div>
                            </div>
                        </template>

                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
import btnModule from "@/components/Custom/BtnModule";
import {isMobile} from "@/utils/index"
    export default {
        name: 'medium-module',
        components: {btnModule},
        props: {
            type: {         //展示类型 preview预览模块 setting设置模块
                type: String,
                default: 'preview'
            },
            index: {        //索引
                type: Number
            },
            animateShow: {     
                type: String
            },
            phoneWidth: {
                type: Number,
                default:1280,
                },
            curpageWidth: {
                type: Number,
                default:1280,
            },
            proportion: {
                type: Number,
                default:1,
            },

            
            modata: {
                type: Object,
                default: function () {
                    return {
                        WName: 'medium',
                        Title: '媒体组件',
                        WID: 1,
                        ModuleName: 'medium-module',
                        WContent: {
                            margin:[],
                        },
                    }
                }
            }
        },
        data() {
            return {
                animateClas:"",
                rootValue:this.$store.state.rootValue||1,
            }
        },
        mounted() {
            // window.addEventListener('scroll', this.handleScroll,true);
            // let name=".imgNav-item_box"+this.index;
            // this.innerBottom=this.$el.querySelector(name).offsetTop;
            // this.innerHeight=window.innerHeight;
            // this.handleScroll();
        },
         beforeDestroy() {
            // window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            // handleScroll(){
            //     if(this.animateClas){
            //         return
            //     }
            //     const seatNumb=(window.scrollY || document.documentElement.scrollTop)+this.innerHeight +20;
            //     if(seatNumb>this.innerBottom){
            //         this.animateClas='animate__animated animate__backInLeft';
            //     }
            // },

            bindPage(item){
                if(!item.btn){
                    this.pageNavigate(item.linkUrl)
                }
            },
           
            pageNavigate(path){
                if(!path){
                    return
                }
                if(/^(https?:|mailto:|tel:)/.test(path)){
                window.open(path)
                }else{
                    this.$router.push(path)
                }
            },



        },
        watch: {
         
        },
        filters: {

        },
    }
</script>
<style>
  .set-prepend_pd8 .el-input-group__prepend{
    padding: 0 8px;
  }
</style>

<style scoped>
.pic2-content{width: 100%;}


.imgNav-1{height: 100%;overflow: hidden;background-color: #fff;display: flex;justify-content: space-between;}
.imgNav-1 .imgNav-item{position: relative;flex: 2;}
.imgNav-item_box{position: relative;width:100%;height:100%;}
/* background-color: #f8f8f8; */
.imgNav-item_img{ width: 100%;height: auto; display: inline-block;vertical-align:top; animation:imgOpacity 650ms linear 1;}

@keyframes imgOpacity{0%{opacity: 0.3;}100%{opacity: 1;}}

.imgNav-4{
    display: grid;
    box-sizing: content-box;
    grid-template-columns: repeat(3,minmax(0,1fr));
    gap: 1px;
    grid-template-rows: auto;
}
.col-span-2{
    grid-column: span 2/span 2;
}

@media (max-width: 600px) {
  .imgNav-1{
    flex-direction: column;
  }



  
}




</style>


